import axios from 'axios';
import { createForumCsrfProtection } from '@/features/forum/services/forumCsrf';
import { forumError } from './forumErrors';
import { clearForumDrafts } from '../services/forumDrafts';

// Session cookies are the actual Drupal auth boundary. No optional custom headers
// or bearer-only authentication: the historical OAuth callback is not enforcement.
export const forumReadClient = axios.create({
  baseURL: process.env.VUE_APP_API || '/', timeout: 30000, withCredentials: true
});
forumReadClient.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401) clearForumDrafts();
  return Promise.reject(error);
});

export const forumWriteClient = axios.create({
  baseURL: process.env.VUE_APP_API || '/', timeout: 30000, withCredentials: true
});
const csrf = createForumCsrfProtection({
  getIdentity: () => ({ uid: localStorage.getItem('uid'), session: localStorage.getItem('user_access_token') }),
  fetchSession: async () => (await forumReadClient.get('/forum/api/v2/session', { timeout: 10000 })).data.data
});
forumWriteClient.interceptors.request.use(config => csrf.prepare(config));
forumWriteClient.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401) clearForumDrafts();
  const payload = error.response && error.response.data;
  if (payload && payload.error && payload.error.code === 'csrf_invalid') csrf.invalidate();
  // No raw config, body, token or server trace leaves the mutation transport.
  return Promise.reject(forumError(error));
});
